import CurrencyCode from 'types/CurrencyCode';
import Plan from 'types/Plan';
import PlanCode from 'types/PlanCode';
import * as styles from './styles/styles.module.scss';
import PlanTypeCard from '../PlanTypeCard';

type Props = {
  planTypes: Plan[];
  handler?(...args: unknown[]): unknown;
  activePlanType?: PlanCode;
  currencyCode: CurrencyCode;
  isCouponApplied?: boolean;
  verifiedCoupon?: any;
};

const PlanTypeCardCollection = ({ planTypes, handler, activePlanType, currencyCode, verifiedCoupon, isCouponApplied }: Props) => (
  <>
    {planTypes.map(option => (
      <PlanTypeCard
        data-testid={`plan-${option.planCode}`}
        key={`plan-${option.planCode}`}
        plan={option}
        onClick={() => handler(option.planCode)}
        isActive={activePlanType === option.planCode}
        currencyCode={currencyCode}
        coupon={verifiedCoupon}
        isCouponApplied={isCouponApplied}
        extraClasses={`${styles.card}`}
      />
    ))}
  </>
);

export default PlanTypeCardCollection;
